import axios, { AxiosError } from 'axios'
import { useAuthStore } from '../store/authStore'

const BASE_URL = '/api/v1'

export const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
})

// Attach access token to every request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// Handle 401 → refresh token → retry
apiClient.interceptors.response.use(
  (res) => res,
  async (error: AxiosError) => {
    const original = error.config as typeof error.config & { _retry?: boolean }
    if (error.response?.status === 401 && !original?._retry) {
      original._retry = true
      const refreshToken = localStorage.getItem('refreshToken')
      if (refreshToken) {
        try {
          const { data } = await axios.post(`${BASE_URL}/auth/refresh`, { refreshToken })
          const newToken = data.data.accessToken
          localStorage.setItem('accessToken', newToken)
          if (original) original.headers!['Authorization'] = `Bearer ${newToken}`
          return apiClient(original!)
        } catch {
          // Clear the zustand store too — otherwise isAuthenticated stays true
          // and ProtectedRoute bounces the user into a broken session
          useAuthStore.getState().clearAuth()
          window.location.href = '/login?expired=1'
        }
      } else {
        useAuthStore.getState().clearAuth()
        window.location.href = '/login?expired=1'
      }
    }
    return Promise.reject(error)
  }
)
